const changePasswordSuccess = {
  '¡Ya cambiamos tu contraseña!': '¡Ya cambiamos tu contraseña!',
  'Ahora podés ingresar a tu cuenta': 'Ahora puedes ingresar a tu cuenta.',
}

export default changePasswordSuccess
